import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type SurveyorsSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_SURVEYORS_SORT_OPTION: SurveyorsSortOption = "newest";

const OPTIONS: SortOption<SurveyorsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function surveyorsSortOptionLabel(option: SurveyorsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function surveyorsSortOptionToParams(option: SurveyorsSortOption): {
  sortBy: "updatedAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "updatedAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "updatedAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortSurveyorsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: SurveyorsSortOption;
  setSortOption: (option: SurveyorsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Surveyors"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
